"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
const LOCAL_STORAGE_PREFIX = "chat-data--";
exports.default = {
  // i.e. @client, and @launcher windows
  // (Synchronised via window `postMessage` calls)
  CROSS_WINDOW: {
    // Cached session ID, necessary for chat resumption
    SESSION_ID: `${LOCAL_STORAGE_PREFIX}session-id`,
    // Last active a.k.a. 'keepalive' timestamp for any chat session
    // (inline, pop-out, or otherwise), necessary so we can only attempt
    // to resume chat sessions within a specified threshold so as to
    // avoid re-opening the chat launcher on stale chat sessions.
    ACTIVE_CHAT_TIMESTAMP: `${LOCAL_STORAGE_PREFIX}active-chat-timestamp`,
    // Last active a.k.a. 'keepalive' timestamp for the pop-out,
    // necessary so we can avoid activating the inline chat if we
    // know there is a pop-out chat window active somewhere
    POP_OUT_ACTIVE_TIMESTAMP: `${LOCAL_STORAGE_PREFIX}pop-out-active-timestamp`,
    // Necessary to cache so that when we resume a chat session,
    // we can still accurately infer "new message" counts for the
    // purposes of notifications, lest the entire message history
    // count appear in notification counters otherwise
    RECEIVED_MESSAGES: `${LOCAL_STORAGE_PREFIX}received-messages`,
    // Name of the theme provided to the ChatLauncher config.
    // Although the theme is passed seamlessly from the @launcher
    // to the @client initially, the applied theme is lost if
    // the session is ever resumed - e.g. via pop-out, or refresh.
    // To mitigate this, the theme name is cached so it can be
    // still be retrieved by the client in these scenarios.
    THEME_NAME: `${LOCAL_STORAGE_PREFIX}theme-name`,
    // URL of the current or most recent page. Stored so that it can
    // be compared on resumption of chat, to capture data about scenarios
    // such as when the user navigates from one page to another.
    MOST_RECENT_PAGE_NAME: `${LOCAL_STORAGE_PREFIX}most-recent-page-name`,
    MOST_RECENT_PAGE_LINK: `${LOCAL_STORAGE_PREFIX}most-recent-page-link`
  },
  // One window, either @client or @launcher (as specified)
  SAME_WINDOW: {
    // For @launcher:
    // The inline chat minimised state, maintained so that when resuming a
    // session, the chat can stay minimised rather than re-opening.
    INLINE_CHAT_MINIMISED_STATE: `${LOCAL_STORAGE_PREFIX}inline-chat-minimised`,
    // For @client:
    // The client context information passed in via config when the chat
    // is first initialised. e.g. whether it's `inline` or `pop-out`.
    // Cached so that it can be reliably retrieved on resume
    CLIENT_CONTEXT: `${LOCAL_STORAGE_PREFIX}client-context`,
    // For @client:
    // Whether the agent has been informed that the user is reaching them
    // via inline/pop-out chat. This is so that the agent can know whether to
    // expect page navigation messages when the user navigates to other NIB pages.
    HAS_INFORMED_AGENT_OF_INLINE: `${LOCAL_STORAGE_PREFIX}has-informed-agent-of-inline`,
    HAS_INFORMED_AGENT_OF_POPOUT: `${LOCAL_STORAGE_PREFIX}has-informed-agent-of-popout`,
    // The time that the chat was started
    CHAT_START_TIME: `${LOCAL_STORAGE_PREFIX}chat-start-time`
  }
};